/**
 * Import depedencies
 */

import { combineReducers } from 'redux';
import localForage from 'localforage';
import { persistReducer } from 'redux-persist';

/**
 * Import reducers
 */

import { connectRouter } from 'connected-react-router';
import { reducer as notificationsReducer } from 'reapop';

import authenticationReducer from './authentication';
import postReducer from './post';
import pageReducer from './page';
import categoryReducer from './category';

/**
 * List all reducers
 */

const authenticationPersistConfig = {
  key: 'authentication',
  storage: localForage,
  whitelist: ['user', 'token'],
};

const postPersistConfig = {
  key: 'post',
  storage: localForage,
};

const pagePersistConfig = {
  key: 'page',
  storage: localForage,
};

const categoryPersistConfig = {
  key: 'category',
  storage: localForage,
};

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    notifications: notificationsReducer(),
    authentication: persistReducer(
      authenticationPersistConfig,
      authenticationReducer
    ),
    post: persistReducer(postPersistConfig, postReducer),
    page: persistReducer(pagePersistConfig, pageReducer),
    category: persistReducer(categoryPersistConfig, categoryReducer),
  });
